import { BaseApi } from './base.api.js';
import { ApiError } from '../errors/api-error.js';

export class DetailedReportProfileApi extends BaseApi {
    constructor(client) {
        super(client, '/detailed-report-profiles');
    }



    async updateSharing(id, data) {
        try {
            return (await this.client.put(`${this.basePath}/${id}/sharing`, data)).data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async setDefault(id, expectedVersion) {
        try {
            return (await this.client.put(`${this.basePath}/${id}/default`, { expectedVersion })).data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async uploadLogo(id, file, expectedVersion) {
        try {
            const form = new FormData();
            form.append('logo', file);
            form.append('expectedVersion', String(expectedVersion));
            return (await this.client.post(`${this.basePath}/${id}/logo`, form)).data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async removeLogo(id, expectedVersion) {
        try {
            return (await this.client.delete(`${this.basePath}/${id}/logo`, {
                params: { expectedVersion },
            })).data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async delete(id, expectedVersion) {
        try {
            return (await this.client.delete(`${this.basePath}/${id}`, {
                params: { expectedVersion },
            })).data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }
}
